import styles from './PartnerSites.less';

import React, { PropTypes } from 'react';

import ExternalLink from 'ExternalLink/ExternalLink';
import { ScreenReaderOnly } from 'seek-style-guide/react';

const linksObject = {
  AU: {
    learningUrl: 'https://www.seeklearning.com.au/?campaigncode=seek_banner_29&sc_trk=skj-courses-link',
    businessUrl: 'https://www.seekbusiness.com.au/?tracking=sk:main:au:nav:bus',
    volunteerUrl: 'https://www.volunteer.com.au/?tracking=SKMAU:main+header'
  },
  NZ: {
    learningUrl: 'https://www.seeklearning.co.nz/?campaigncode=seek_banner_29&sc_trk=skj-courses-link',
    businessUrl: 'https://www.seekbusiness.com.au/?site=nz&tracking=sk:main:nz:nav:bus',
    volunteerUrl: 'https://seekvolunteer.co.nz/?tracking=SKMNZ:main+header'
  }
};

const err = () => {
  const e = new Error('Link key not found');
  e.name = 'PartnerSiteError';
  throw e;
};

const localeLens = links => locale => links ? links[locale] : err();
const linkLens = locale => link => typeof locale[link] === 'string' && locale[link] || err();

export default class PartnerSites extends React.Component {
  static propTypes = {
    locale: PropTypes.string.isRequired
  };

  render() {
    const { locale } = this.props;
    const linkView = linkLens(localeLens(linksObject)(locale));

    return (
      <nav role="navigation">
        <ScreenReaderOnly>
          <h1>Partner Sites</h1>
        </ScreenReaderOnly>
        <ul className={styles.list}>
          <li><a className={`${styles.link} ${styles.link_isJobs}`} title="SEEK Jobs">Jobs</a></li>
          <li>
            <ExternalLink
              analytics="header:courses"
              className={`${styles.link} ${styles.link_isLearning}`}
              href={linkView('learningUrl')}
              title="SEEK Learning">Courses</ExternalLink>
          </li>
          <li>
            <ExternalLink
              analytics="header:business+for+sale"
              className={`${styles.link} ${styles.link_isBusiness}`}
              href={linkView('businessUrl')}
              title="SEEK Business">Businesses for sale</ExternalLink>
          </li>
          <li>
            <ExternalLink
              analytics="header:volunteering"
              className={`${styles.link} ${styles.link_isVolunteering}`}
              href={linkView('volunteerUrl')} title="SEEK Volunteer">Volunteering</ExternalLink>
          </li>
        </ul>
      </nav>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/Header/components/PartnerSites/PartnerSites.js
 **/